module.exports = __webpack_public_path__ + "img/suggestion-semipublic.06a90153.png";